import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response, URLSearchParams} from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class HelpService {

  constructor(private http: Http) {
  }

  getModulos() {

    const url = 'getModulos.php';

    const options = new RequestOptions({headers: new Headers({'Content-Type': 'application/json'})});

    return this.http.get(url, options).map((res: Response) => res.json());
  }


  getHelps(search: string) {

    const url = 'getHelps.php';

    const params: URLSearchParams = new URLSearchParams();
    params.set('search', search);

    const options = new RequestOptions({headers: new Headers({'Content-Type': 'application/json'}), 'search': params});

    return this.http.get(url, options).map((res: Response) => res.json());
  }

  getHelp(codigo: string) {

    const url = 'getHelp.php';

    const params: URLSearchParams = new URLSearchParams();
    params.set('codigo', codigo);

    const options = new RequestOptions({headers: new Headers({'Content-Type': 'application/json'}), 'search': params});

    return this.http.get(url, options).map((res: Response) => res.json());
  }

  deleteHelp(codigo: number) {

    const url = 'deleteHelp.php';

    const params: URLSearchParams = new URLSearchParams();
    params.set('codigo', codigo.toString());

    const options = new RequestOptions({headers: new Headers({'Content-Type': 'application/json'}), 'search': params});

    return this.http.delete(url, options).map((res: Response) => res.json());
  }

  addHelp(help) {
    const url = 'addHelp.php';

    const headers = new Headers({'Content-Type': 'application/json'});
    const params: URLSearchParams = new URLSearchParams();
    params.set('modulo', help.modulo);
    params.set('pergunta', help.pergunta);
    params.set('respostaSimplificada', help.respostaSimplificada);
    params.set('caminho', help.caminho);
    params.set('respostaCompleta', help.respostaCompleta);

    const options = new RequestOptions({headers: headers, 'search': params});

    return this.http.post(url, null, options)
      .map(res => res.json());
  }

  updateHelp(help) {
    const url = 'updateHelp.php';

    const headers = new Headers({'Content-Type': 'application/json'});
    const params: URLSearchParams = new URLSearchParams();
    params.set('codigo', help.codigo);
    params.set('modulo', help.modulo);
    params.set('pergunta', help.pergunta);
    params.set('respostaSimplificada', help.respostaSimplificada);
    params.set('caminho', help.caminho);
    params.set('respostaCompleta', help.respostaCompleta);

    const options = new RequestOptions({headers: headers, 'search': params});

    return this.http.put(url, null, options)
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/help/help.service.ts